import { RuntimeEnvironmentOptions, getEnvFromHostname, loadBranch } from '@growtherapy/analytics';

/**
 * Initialize Branch.io for smart banners. Both keys are baked in at build time;
 * getEnvFromHostname picks prod vs test at runtime by hostname
 */
export function initBranch() {
  const branchEnv = getEnvFromHostname({
    hostname: window.location.hostname,
    defaultEnvironment: RuntimeEnvironmentOptions.local,
  });
  const branchKey =
    branchEnv === RuntimeEnvironmentOptions.production
      ? import.meta.env.VITE_BRANCH_KEY_PROD
      : import.meta.env.VITE_BRANCH_KEY_TEST;
  if (branchKey) {
    loadBranch({ branchKey });
  }
}
